import { ColSize } from "antd/lib/col";
import Form from "antd/lib/form";
import styled from "styled-components";
import ScreenHelper from "components/Styled/ScreenHelper";

declare type ColSpanType = ColSize;

export const InputColLayout: { [key: string]: ColSpanType } = {
  xs: { span: 22, offset: 1 },
  sm: { span: 22, offset: 1 },
  md: { span: 12, offset: 6 },
  lg: { span: 12, offset: 6 },
  xl: { span: 12, offset: 6 },
};


export const ButtonColLayout: { [key: string]: ColSpanType } = {
  xs: { span: 22, offset: 0 },
  sm: { span: 22, offset: 0 },
  md: { span: 8, offset: 8 },
  lg: { span: 8, offset: 8 },
  xl: { span: 8, offset: 8 },
};

export const InputLayout = {
  labelCol: {
    xs: { span: 24, },
    sm: { span: 24, },
    md: { span: 24, },
    lg: { span: 6, },
    xl: { span: 6, },
  },
  wrapperCol: {
    xs: { span: 22 },
    sm: { span: 22, },
    md: { span: 22, },
    lg: { span: 18, },
    xl: { span: 18, },
  },
};

export const StyleEmailConfirmationForm = styled(Form)`


  ${ScreenHelper.down('sm')`
    max-width: 300px;
    min-width: 300px;
  `};

  .emailConfirmationBtn{
    justify-content: center;
    align-items: center
    text-align: center;
  };

  .resendEmailBtn{      
    // margin-bottom: 10px;    
    ${ScreenHelper.up('md')`
        width: 50%
    `};
     
  };

  .confirmEmailBtn{      
    margin-bottom: 10px;  
    ${ScreenHelper.up('md')`
        width: 40%
    `};
   };

`;